import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'
import { prepareData } from 'utils/googleData'
import { Check, Close } from 'components/Icons/Icons'
import Link from 'components/Link'

export interface IComparison {
    description: string
    children: React.ReactNode
}
export function Comparison(props) {
    const {
        enable,
        title = 'iCloudReady vs...',
        name,
        description,
        cta,
        direction,
        footerUrl,
        style,
        gatsbyImage,
        gatsbyImage2,
        gatsbyImage3,
        text,
        gatsbyImageSrc,
        features,
        headers,
        rows,
        footerText,
    } = prepareData({ props })
    // console.log('rows', JSON.stringify(rows))
    // console.log('headers', JSON.stringify(headers))
    const tableHeaders = headers ? headers.map((header) => header.name) : []

    return (
        <section className="mt-8">
            <div id="comparison" className="mx-auto max-w-5xl">
                <div className="flex items-end justify-between">
                    <div>
                        <h2 className="m-0">{title}</h2>
                        <p className="m-0">{description}</p>
                    </div>
                    ,
                    {gatsbyImage && (
                        <div>
                            <GatsbyImage className="max-w-[530px]" alt={title} image={gatsbyImage} />
                        </div>
                    )}
                </div>
                <div className="article-content mt-12 overflow-x-auto">
                    <table className="min-w-full">
                        <thead>
                            <tr>
                                {tableHeaders.map((header, index) => (
                                    <th key={index}>{header}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {rows?.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    {tableHeaders.map((header, cellIndex) => {
                                        // For the first column, display the 'name'
                                        if (cellIndex === 0) {
                                            return <td key={cellIndex}>{row.name}</td>
                                        }
                                        const value = row[headers[cellIndex].name] === 'true'
                                        return (
                                            <td key={cellIndex}>
                                                {value ? <Check className="h-4 w-4" /> : <Close className="h-4 w-4" />}
                                            </td>
                                        )
                                    })}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            {cta?.url && (
                <p>
                    <Link className="center  mb-3 justify-between pb-3  text-[18px] font-semibold" to={cta?.url}>
                        <span>{cta?.label}</span>
                    </Link>
                </p>
            )}
        </section>
    )
}
export default Comparison
